export default function verifyKindOfPerson(user, type) {
  if (user?.user) {
    const kindsOfPerson = user.user.ds_papel.split(',');
    const noSpaces = kindsOfPerson.map((kind) => kind.trim());

    return noSpaces.includes(type);
  }
}
